import React, { useContext } from 'react';
import Navigation from '@this/template/layout/Navigation/Navigation';
import User from '@this/template/layout/User/User';
import ThemeContext from '@this/template/contexts/themeContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '@this/template/layout/Aside/Aside';
import { adminMenu } from '@this/impl/menus/admin';

const AdminAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	return (
		<Aside>
			<AsideHead className='text-center'>
				{asideStatus && <img style={{ width: '150px' }} src='/images/fw.png' alt='Logo' />}
			</AsideHead>
			<AsideBody>
				<div className='p-2'>
					<Navigation id='admin' menu={adminMenu} />
				</div>
			</AsideBody>
			<AsideFoot>
				<User collapsible asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideFoot>
		</Aside>
	);
};

export default AdminAside;
